import { Form, Switch } from 'antd-v5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SettingsContent } from '../../../components/SettingsContent';
import DescriptionBox from '../../../../../../components/Layout/DescriptionBox';

export const AssociateVisibilitySettings = ({ form }) => {
  return (
    <SettingsContent title="LIMIT ASSOCIATE VISIBILITY" icon={<FontAwesomeIcon icon={['fas', 'lock']} />} className="w-100-P">
      <DescriptionBox
        className="w-100-P"
        description="By enabling this setting, you will block associates from being able to access client profiles or conversations of clients they are not assigned to."
        input={
          <Form.Item name="limitAssociateVisibilityEnabled" valuePropName="checked">
            <Switch />
          </Form.Item>
        }
      />
    </SettingsContent>
  );
};
